import './style.scss'
import { Button, Modal } from 'antd'
import { FC, memo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { CreateVideo } from '@/assets/svg'

interface IProps {
  preview: {
    url: string
    title?: string
    id?: number
  }
  btnsShow?: boolean
  onCancel?: () => void
}

const VideoModal: FC<IProps> = (props) => {
  const navigate = useNavigate()
  const { preview, onCancel, btnsShow } = props
  const videoRef = useRef<HTMLVideoElement>(null)

  if (!preview) return null

  const toCreateVideo = () => {
    navigate(`/create-video/${preview.id}`)
  }

  return (
    <Modal
      title={preview?.title || '预览'}
      open={!!preview}
      width="56%"
      footer={null}
      onCancel={() => {
        videoRef.current?.pause()
        onCancel?.()
      }}
      className="commom-modal"
    >
      <div className="video-modal-content">
        <div className="content-video">
          <video ref={videoRef} autoPlay controls src={preview.url} />
        </div>
        {btnsShow && (
          <div className="btns">
            <Button type="primary" icon={<CreateVideo width={20} height={20} />} onClick={toCreateVideo}>
              创建新视频
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default memo(VideoModal)
